import BaseProxy from "../../base-proxy";

/**
 * @class GetCompanyServicesProxy
 * @description Class used for communicating GET requests with company services API.
 * @author Koh Keng Hong
 * @version 1.0
 * @since December 06, 2018
 */
export default class GetCompanyServicesProxy {
  /**
   * @async
   * @function execute
   * @param input - Input parameter instance.
   * @param {String} input.id - Company id.
   * @param {String} input.authToken - Token used for issuing authenticated request.
   */
  async execute(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/companies/${input.id}/company-services/`;

    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }
}
